













import Vue from "vue";
import HeaderMainTopSearchbar from "./HeaderMainTopSearchbar.vue";
import HeaderMainTopLeft from "./HeaderMainTopLeft.vue";

export default Vue.extend({
  name: "HeaderMainTop",
  components: {
    HeaderMainTopSearchbar,
    HeaderMainTopLeft
  }
});
